import { combineReducers } from 'redux';
import SettingsReducer from './SettingsReducer';
import UserReducer from './UserReducer';

export default combineReducers({
  settings: SettingsReducer,
  user: UserReducer,
});